import { say } from "../words.ts";
/**
 * The game needs WebGL (ADR-061, "the game needs WebGL"): Phaser 4.2.1's `NineSlice` has only a WebGL
 * renderer, so under the Canvas renderer `Phaser.AUTO` can fall back to, every canvas frame would vanish
 * without an error. The page asks for `Phaser.WEBGL` and, where WebGL is missing, says so in a sentence
 * instead of starting.
 */

/**
 * Whether this browser can create the WebGL context Phaser's renderer asks for: a WebGL 1 context (`webgl`;
 * Phaser 4.2.1 never asks for `webgl2`) with the two extensions its renderer throws without,
 * `ANGLE_instanced_arrays` and `OES_vertex_array_object`. The probe context is released at once, so it does not
 * count against the browser's limit on live contexts.
 *
 * @param doc The document to create the probe canvas in.
 * @returns True when a `webgl` context with both extensions can be created.
 */
export function webglAvailable(doc: Document = document): boolean {
  try {
    const canvas = doc.createElement("canvas");
    const context = canvas.getContext("webgl") ?? canvas.getContext("experimental-webgl");
    if (!(context instanceof WebGLRenderingContext)) {
      return false;
    }
    const extensions = context.getSupportedExtensions() ?? [];
    context.getExtension("WEBGL_lose_context")?.loseContext();
    return extensions.includes("ANGLE_instanced_arrays") && extensions.includes("OES_vertex_array_object");
  } catch {
    return false;
  }
}

/**
 * Shows the sentence in place of the game.
 *
 * @param host The element that holds it.
 */
export function showWebglMissing(host: HTMLElement): void {
  host.textContent = say("floor.webgl");
  host.hidden = false;
}
